import { LABEL_SMALL, LABEL_XS } from 'Shared/styles/designConstants';
import styled from 'styled-components';

export const PromptContainer = styled.div`
  margin-top     : 16px;
  display        : flex;
  flex-direction : column;
  align-items    : flex-start;
  justify-content: center;
  width          : 100%;
`;

export const PromptText = styled.p`
  ${LABEL_SMALL.DEFAULT}
  background-color: #FFF8E1;
  border          : 1px solid #FFE081;
  padding         : 10px;
  border-radius   : 8px;
`;

export const CheckboxContainer = styled.div`
  display    : flex;
  align-items: center;
  margin-top : 16px;
  cursor     : pointer;
`;

export const CustomCheckbox = styled.div<{ checked: boolean }>`
  width        : 20px;
  height       : 20px;
  border       : 2px solid #ccc;
  border-radius: 4px;
  margin-right : 8px;
  background   : ${props => props.checked ? '#0066FF' : '#fff'};
  position     : relative;

  &:after {
    content     : '';
    display     : ${props => props.checked ? 'block' : 'none'};
    width       : 6px;
    height      : 12px;
    border      : solid #fff;
    border-width: 0 2px 2px 0;
    position    : absolute;
    top         : 1px;
    left        : 5px;
    transform   : rotate(45deg);
  }
`;

export const Label = styled.span`
  ${LABEL_XS.DEFAULT}
  font-size: 14px;
`;
